module.exports = __webpack_public_path__ + "img/filigrana-incantalia-left.365da8f2.png";